import React, {Fragment} from 'react';
import {Route, Switch, Redirect, withRouter} from 'react-router-dom';
import gql from 'graphql-tag';
import {Query} from 'react-apollo';

import ErrorPage from '../common/ErrorPage';
import NotFound from '../common/NotFound';
import {Toast} from '../common/Toast';
import Loader from '../common/Loader';
import Header from '../Header';
import Footer from '../Footer';
import {ROUTES_LOGGED_OUT, ROUTES_LOGGED_IN, ROUTE_LOGIN} from '../../const';

const GET_USER = gql`
  query user {
    currentUser {
      firstName
      lastName
      defaultView
      _id
    }
  }
`;

const Routes = ({history}) => {
  return (
    <Query query={GET_USER}>
      {({data = {}, loading, error, refetch}) => {
        const {currentUser} = data;
        if (loading) return <Loader />;
        if (error) return <ErrorPage text={error.message} />;
        let defaultView = currentUser ? (currentUser.defaultView ? currentUser.defaultView : '/skills') : '/skills';
        const {
          location: {search}
        } = history;
        if (search) {
          const params = new URLSearchParams(search);
          defaultView = params.get('redirect');
        }

        return (
          <Fragment>
            <Header user={currentUser} history={history} refetch={refetch} />
            <Toast />
            <div className="routes-container">
              <Switch>
                {currentUser ? (
                  <Fragment>
                    <Switch>
                      <Redirect from={'/'} exact strict to={defaultView} />
                      {ROUTES_LOGGED_IN.map(({pathName, Component}) => (
                        <Route key={pathName} path={pathName} exact component={Component} />
                      ))}
                      <Route component={NotFound} />
                    </Switch>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Switch>
                      {ROUTES_LOGGED_OUT.map(({pathName, Component}) => (
                        <Route
                          key={pathName}
                          path={pathName}
                          exact
                          render={({history}) => <Component refetch={refetch} history={history} user={currentUser} />}
                        />
                      ))}
                      <Redirect from={'/*'} strict exact to={ROUTE_LOGIN} />
                    </Switch>
                  </Fragment>
                )}
              </Switch>
            </div>
            <Footer user={currentUser} history={history} refetch={refetch} />
          </Fragment>
        );
      }}
    </Query>
  );
};

export default withRouter(Routes);
